import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'fileName',
    'fileInput',
    'singleOrMultipleFilesLabel',
    'fileInputContainer',
    'fileState',
  ];

  connect() {
    this.setFileName(this.fileInputTarget, this.fileNameTarget, false);
    this.checkIfError();
  }

  // ACTIONS

  changeBorderColor(_event) {
    if (this.fileInputTarget.value) {
      this.replaceClassByPrefix(this.fileInputContainerTarget, 'border-', 'border-primary');
      if (this.hasFileStateTarget) {
        this.fileStateTarget.classList.add('d-none')
      }
    } else {
      this.replaceClassByPrefix(this.fileInputContainerTarget, 'border-', 'border-gray-300');
      if (this.hasFileStateTarget) {
        this.fileStateTarget.classList.remove('d-none')
      }
    }
  }

  replaceClassByPrefix(el, prefix, newClass) {
    let classes = el.className.split(' ').filter(c => !c.startsWith(prefix));
    el.className = classes.join(' ').trim();
    el.classList.add(newClass);
    return el;
  }

  updateFileName(_event) {
    this.setFileName(this.fileInputTarget, this.fileNameTarget, true);
    this.changeBorderColor();
    this.fileNameTarget.classList.remove('d-none');

    if (this.fileInputTarget.value) {
      this.singleOrMultipleFilesLabelTarget.classList.add('d-none');
    } else {
      this.singleOrMultipleFilesLabelTarget.classList.remove('d-none');
    }
  }

  checkIfError() {
    if(this.fileInputContainerTarget.querySelector('.invalid-feedback')) {
      this.fileNameTarget.classList.add('d-none');
    }
  }

  // METHODS

  setFileName(target, nameTarget, voidName) {
    let fileName = nameTarget.innerHTML.trim();

    if (target.value) {
      fileName = target.value.split('\\').slice(-1).toString();
    } else if (voidName) {
      fileName = '';
    }

    nameTarget.innerHTML = fileName.replace(
      /(.{10}).+(.{10})\.(.+)/,
      '$1...$2.$3'
    );
  }
}
